<template>
  <div 
    v-if="active" 
    id="lose-calculation-warning-modal" 
    :class="{'is-active': active}"
    class="ec-modal ec-lose-calculation-warning-modal">
    <div class="ec-modal-main is-warning is-loading animated fadeIn">
      <a 
        href="#" 
        class="close-icon modal-close" 
        @click.prevent="closeModal"/>
      <div class="ec-modal-headline">{{ $t('modals.lose_calculation_warning.title') }}</div>
      <div class="ec-modal-text">
        <span v-html="$t('modals.lose_calculation_warning.msg')"/>
        <span v-if="!authCheck">{{ $t('modals.lose_calculation_warning.msg_login') }}</span>
      </div>
      <div class="ec-modal-btn-wrapper">
        <button 
          v-if="authCheck" 
          id="ec-modal-variable-cancel" 
          class="ec-modal-btn-cancel btn is-blue modal-close"
          @click.prevent="saveCalculation()">
          {{ $t('modals.lose_calculation_warning.ok_btn') }}
        </button>
        <button 
          v-if="!authCheck" 
          id="ec-modal-variable-cancel" 
          class="ec-modal-btn-cancel btn is-blue"
          @click.prevent="login()">
          {{ $t('modals.lose_calculation_warning.login_btn') }}
        </button>
        <button 
          id="ec-modal-lose-calc-ok" 
          class="ec-modal-btn-ok btn" 
          @click="goAway">
          {{ $t('modals.lose_calculation_warning.continue_without_save_btn') }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
    import Modal from './Modal.mixin.vue'
    import { redirect } from '../utility'

    export default {
        mixins: [Modal],
        data: function () {
            return {
                href: null,
                authCheck: AuthCheck
            }
        },
        created() {
            let modal = this

            $('a:not(a[href*="#"]):not(.no-lose-calculation-warning):not(.cursor-pointer), .lose-calculation-warning').on('click', function (event) {
                if (!modal.$store.isCalculationSaved) {
                    event.preventDefault()
                    modal.href = $(this).attr('href')
                    modal.active = true
                    exitModal = false
                }
            })
        },
        methods: {
            goAway() {
                return redirect(this.href)
            },
            login() {
                this.$cookie.set('autocall-change-calculation-name', 1, 1)

                redirect(eventsuiteLoginService)
            },
            saveCalculation() {
                this.closeModal()
                this.$event.$emit('change-calculation-name')
            }
        }
    }
</script>